<div class="container-fluid" id="c-f">
	<div class="row">
		<div class="col-lg-12 col-md-12 col-sm-12 col-12">
			<div class="card custom-card">
				<div class="card-body">
					<p>PAYMENT HISTORY</p>
					<div *ngIf="paymentHistory.length == 0">No Transaction Recorded Yet</div>
					<div class="table-responsive" *ngIf="paymentGateway == 'interswitch' && paymentHistory.length > 0">
						<table class="table">
							<tr>
								<th>Name</th>
								<th>Transaction Reference</th>
								<th>Transaction Date</th>
								<th>Amount</th>
								<th>Response</th>
								<th>Status</th>
								<th>Action</th>
							</tr>
							<tr *ngFor="let h of paymentHistory">
								<td>{{fullName}}</td>
								<td>{{h.retrieval_ref_no}}</td>
								<td>{{h.created_at}}</td>
								<td>{{h.amount/100}}</td>
								<td>{{h.status}}</td>
								<td><span class="text-danger" *ngIf="h.confirmed == 'N'">Not successful</span><span
										class="text-success" *ngIf="h.confirmed == 'Y'">Successful</span></td>
								<td></td>
							</tr>
						</table>
						<hr />
					</div>
					<div class="table-responsive" *ngIf="paymentGateway !== 'interswitch' && paymentHistory.length > 0">
						<table class="table">
							<tr>
								<th>Name</th>
								<th>For</th>
								<th>Transaction Reference</th>
								<th>Transaction Date</th>
								<th>Amount</th>
								<th>Status</th>
								<th>Action</th>
							</tr>
							<tr *ngFor="let h of paymentHistory">
								<td>{{fullName}}</td>
								<td>{{h.session_year}} {{h.term}}</td>
								<td *ngIf="h.reference">{{h.reference}}</td>
								<td *ngIf="h.slip"><button mat-raised-button class="btn-secondary"
										(click)="viewSlip(h.slip)">View
										Slip</button></td>
								<td>{{h.created_at}}</td>
								<td>{{h.amount/100 | currency:'NGN':'symbol-narrow'}}</td>
								<td>
									<span class="status-td {{
                         h.status.toLowerCase() == 'success' ? 'success-tag' : 
                        h.status.toLowerCase() == 'approved' ? 'success-tag' : 
                        h.status.toLowerCase() == 'failed' ? 'failed-tag' :
                        h.status.toLowerCase() == 'rejected' ? 'failed-tag' :
                        h.status.toLowerCase() == 'pending' ?  'pending-tag' : 'info-tag'
                    }}">
										{{h.status}}
									</span>
								</td>
								<td>
									<span class="d-flex flex-wrap" style="gap: 1rem;">
										<!-- <button mat-raised-button (click)="printPDF(h)" color="primary">Print</button> -->
										<button mat-raised-button (click)="requery(h)"
											*ngIf="h.reference">Requery</button>
										<!-- <button mat-raised-button (click)="requery(h)"
											*ngIf="h.reference && (h.purpose.toLowerCase() == 'tuition')">Requery</button> -->
									</span>
								</td>
							</tr>
						</table>
						<hr />
					</div>
				</div>
			</div>

		</div>


	</div>
	<img id='imgToExport' src='{{company_logo}}' style='display:none' />

</div>